import { FormFieldTypes } from "../../../components/forms/libs/data/formFieldType";
import { validationTypes } from "../../../components/forms/libs/data/ValidationTypes";
import Buttons from "../../../components/ui/button/Buttons";
import { AppIcons } from "../../../data/appIcons";
import TitleWrapper from "../../../components/ui/titlewrapper/TitleWrapper";
import AccordionWrapper from "../../../components/ui/accordion/AccordionWrapper";
import { FileFormats } from "../../../components/forms/libs/data/fileFormatTypes";

const initState = {
  emailAddress: '',
  password: ''
};

export const LoginFormData = {
  name: "User Form",
  initialState: initState,
  section: [
    {
      title: "User Information Section",
      row: {},
      style: {
        sectionStyle: "row mb-3 login-form",
      },

      fields: [
        {
          id: "emailAddress",
          label: "Email Address",
          Field_Name: "Email Address",
          fieldType: FormFieldTypes.INPUT,
          dataField: "emailAddress",
          fieldSetting: {
            placeholder: "Please Enter User Name",
            allowSpace: true,
            textareaRows: 4,
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-12 col-md-12 validation-left-0 ",
          },
        },
        {
          id: "password",
          label: "Password",
          Field_Name: "Password",
          fieldType: FormFieldTypes.PASSWORD,
          dataField: "password",
          fieldSetting: {
            placeholder: "Please Enter Password",
            allowSpace: true,
            textareaRows: 4,
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-12 col-md-12 validation-left-0 ",
          },
        },
      ],
    },
  ],
};
